import React from 'react';
import { Link } from 'react-router-dom';

const RestaurantesIndex = () => {
  return (
    <div className="p-6 max-w-4xl">
      <h1 className="text-2xl font-semibold text-gray-800">Restaurantes</h1>
      <p className="mt-2 text-gray-600">
        Módulo base para operación de restaurantes. Se clonó la configuración de recetas para iniciar el trabajo.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl">
        <Link
          to="/restaurantes/clasificacion-recetas/categorias"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">📁</span>
          <h2 className="mt-2 font-semibold text-gray-900">Clasificación de recetas</h2>
          <p className="mt-1 text-sm text-gray-500">Categorías, subcategorías, familias y jerarquía.</p>
        </Link>

        <Link
          to="/restaurantes/clasificacion-recetas/recetas"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">📜</span>
          <h2 className="mt-2 font-semibold text-gray-900">Recetas</h2>
          <p className="mt-1 text-sm text-gray-500">Listado y edición de recetas.</p>
        </Link>

        <Link
          to="/restaurantes/operaciones/pedidos"
          className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <span className="text-lg">🧾</span>
          <h2 className="mt-2 font-semibold text-gray-900">Operaciones</h2>
          <p className="mt-1 text-sm text-gray-500">Pedidos, acceso a mesas y menú (demo).</p>
        </Link>
      </div>
    </div>
  );
};

export default RestaurantesIndex;
